import { render, staticRenderFns } from "./TestimCard4.vue?vue&type=template&id=6f88ff30&scoped=true&"
import script from "./TestimCard4.vue?vue&type=script&lang=js&"
export * from "./TestimCard4.vue?vue&type=script&lang=js&"
import style0 from "./TestimCard4.vue?vue&type=style&index=0&id=6f88ff30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88ff30",
  null
  
)

export default component.exports